import React from 'react'
import style from './style.module.sass'
import Tonality from './Tonality'
import { useSelector } from 'react-redux'
import config from '../../../../config'
import LanguageLevelBar from './LanguageLevelBar'
import ComplianceLevelBar from './ComplianceLevelBar'

function LinguisticParams ({currentBenchmarkSettings}) {

  const resultData = useSelector(state => state.analyseData.result.resultData)

  const showLanguage = resultData.formulaLanguageLevel > -1
  const showCompliance = currentBenchmarkSettings?.settings?.dataCompliance?.values?.enabled
  console.log('currentBenchmarkSettings',currentBenchmarkSettings)

  return <div className={`${style.mainCont} d-flex`} style={{ gap: '12px' }}>
    {Object.keys(config.tonalityParameters).filter(v => resultData[v] !== undefined).length > 0 && (
      <div style={{ flex: 1, display: 'flex' }}><Tonality/></div>
    )}
    {(showLanguage || showCompliance) ?
      <div className="d-flex flex-column" style={{ gap: '12px', flex: '0 0 calc(50% - 6px)' }}>
        {showLanguage && <LanguageLevelBar/>}
        {showCompliance && <ComplianceLevelBar/>}
      </div> : <></>
    }
  </div>
}

export default LinguisticParams
